// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';

export function Eyebrow({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'mb-3 block font-mono text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
}
